export const required = (value: string) =>
  value ? undefined : "A value is required.";



// WEBPACK FOOTER //
// ./src/validators.ts